var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { BORDER_COLOR } from '../constants';
export var Select = styled.select(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 2px solid ", ";\n  border-radius: 4px;\n  height: 45px;\n  margin: 5px 0;\n"], ["\n  border: 2px solid ", ";\n  border-radius: 4px;\n  height: 45px;\n  margin: 5px 0;\n"])), BORDER_COLOR);
var templateObject_1;
//# sourceMappingURL=Select.js.map